module.exports = __webpack_public_path__ + "img/loading.a4afac23.gif";